package empiresmp.feature.gallery.model

import kotlinx.serialization.Serializable

@Serializable
internal class PagedGalleryModel<T>(
    val data: List<GalleryItem>,
    val total: Long,
    val page: Int,
    val currentPageAmount: Int = data.size
)
